'use client';
import React from 'react';
import { ContactCardContainer } from './styles';
import { CardProps } from '@mui/material';

interface Props extends CardProps {
    children?: React.ReactNode;
}

export const ContactCard = ({ children, ...cardProps }: Props) => {
    return <ContactCardContainer {...cardProps}>{children}</ContactCardContainer>;
};
